/*********************************************************************************************
* Splide product
	*
*/

document.addEventListener('DOMContentLoaded', function() {

    var routineSections = document.querySelectorAll('[data-section-product-review-id]');

    routineSections.forEach(function(section) {
        var id = '.mm-product-review-splide';
        var splideElem = document.querySelector(id);
        var scrollCounter = 0;

        // Crée une instance Splide et la monte
        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : true,
            pagination  : false,
            gap         : '10px',
            fixedWidth  : '310px',
            perMove     : 1,
            omitEnd     : true,
            padding     : {
                left: '0px', 
                right: '0px'
            },
            breakpoints : {
                768: {
                    padding         : {
                        left: '15px', 
                        right: '15px' 
                    }
                }
            }
        }).mount();

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function(e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    });
});
